<!--
 * @Description  : 退票表格展示
-->

<template minapp="mpx" xlang="wxml">
  <view class="content-table">
    <view wx:if="{{tableValue.title}}" class="title">
      <image class="title-icon" src="{{iconSrc}}"></image>
      <view class="title-text">{{ tableValue.title }}</view>
    </view>

    <!-- <view wx:if="{{tableValue.notes}}">
      <slot name="{{'tab-notes'}}"></slot>
    </view> -->
    <!-- ceshi -->
    <table class="main-table">
      <tbody>
        <tr>
          <th width="{{tableValue.tabWidth}}">{{ tableValue.tableth[0] }}</th>
          <th>{{ tableValue.tableth[1] }}</th>
        </tr>
        <tr wx:for="{{tableValue.tablelist}}" wx:key="index" class="table-content">
          <td>
            <rich-text nodes="{{ item.title }}"></rich-text>
          </td>
          <td>
            <rich-text nodes="{{item.content}}"></rich-text>
            <view class="content-tip" wx:if="{{item.tip}}">{{ item.tip }}</view>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <view class="item-text">11</view>
    <view wx:if="{{ tableValue.tip }}" class="tip">{{ tableValue.tip }}</view> -->
    <view wx:if="{{tableValue.tip}}" class="tip">
      <view class="item-text"></view>
      <rich-text nodes="{{tableValue.tip}}"></rich-text>
    </view>
    <text wx:if="{{tableValue.prompt}}" class="prompt">{{ tableValue.prompt }}</text>
    <view wx:if="{{tableValue.caveat}}" class="caveat">
      {{ tableValue.caveat }}
    </view>

    <image wx:if="{{isShowTabIcon}}" class="tab-icon" src="{{imgSrc}}"></image>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      title: {
        type: String,
        value: '发车前取票方式说明'
      },
      tableValue: {
        type: Object,
        value: () => {}
      },
      isShowTabIcon: {
        type: Boolean,
        value: false
      }
    },
    data() {
      return {
        warnIcon: 'https://img-hxy021.didistatic.com/static/starimg/img/PDWB6eY4CT1685280567701.png',
        imgSrc: 'https://dpubstatic.udache.com/static/dpubimg/tuXMEH7OgWQGSylGuPx0R.png',
        iconSrc: 'https://dpubstatic.udache.com/static/dpubimg/q9hniug5T__r0nB2gQrLx.png'
      }
    }
  })
</script>

<style scoped lang="stylus">
  // .content-notes
  .content-table
    position relative
    opacity 1
    display flex
    flex-direction column
    padding-bottom 12px
    box-sizing border-box
    background #FFFFFF
    z-index 0
    .title
      display flex
      height 46px
      align-items center
      margin 0 12px
      border-bottom 0.5px rgba(0, 0, 0, 0.08) solid
      font-family PingFangSC-Medium
      font-size 16px
      font-weight normal
      line-height 19px
      letter-spacing 0px
      color #1473FF
      .title-icon
        width 18px
        height 18px
        margin-right 4px
    .main-table
      margin 12px 12px 0
      border-radius 4px
      border-collapse collapse
      margin-bottom 12px
      border-radius 4px
      overflow hidden
      th, td
        border 1px solid #e5e5e5
        padding 8px 12px
        box-sizing border-box
        color #666
        font-size 14px
      th
        text-align left
        padding 8px 12px
        background rgba(231, 241, 255, 0.3)
        box-sizing border-box
        border-color rgba(0, 0, 0, 0.08)
        font-family PingFangSC-Regular
        font-size 14px
        font-weight normal
        line-height 16px
        letter-spacing 0px
        color #666666
      td
        box-sizing border-box
        padding 12px
        background #fff
        vertical-align middle
        font-family PingFangSC-Regular
        font-size 14px
        font-weight normal
        line-height 16px
        letter-spacing 0px
        color #666666
        z-index 1
        .label
          display flex
          margin-bottom 8px
          &:last-child
            margin 0
        .label-text
          width 70px
          float left
          flex-shrink 0
          white-space nowrap
    .tip
      font-family PingFangSC-Regular
      font-size 14px
      font-weight normal
      line-height 18px
      letter-spacing 0px
      color #666666
      margin 0 12px 12px
      display flex
      flex-direction row
      .item-text::before
        content ''
        display inline-block
        width 4px
        height 4px
        background #D8D8D8
        vertical-align middle
        margin-right 5px
    .prompt
      margin 0 12px
      box-sizing border-box
      padding 8px 10px
      background #FFF4EE
      color #FF7D41
      border-radius 8px
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      line-height 18px
      letter-spacing 0px
    .content-tip
      margin-top 8px
    .caveat
      margin 0 12px
      border-radius 8px
      padding 8px 10px
      background #FFF4EE
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      line-height 18px
      color #FF7D41
    .tab-icon
      position absolute
      right 8px
      top 6.6px
      width 48px
      height 50.4px
      opacity 1
      z-index 2
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>